import React from 'react';
import { styled } from 'linaria/react';
import { usePrice } from '@jetshop/core/hooks/usePrice';
import t from '@jetshop/intl';
import { useContext } from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { css, cx } from 'linaria';

const Wrapper = styled('div')`
  max-width: 100%;
  flex-wrap: wrap;
  position: relative;
`;
const NormalPrice = styled('div')``;
const OldPrice = styled('div')`
  text-decoration: line-through;
`;
const NewPrice = styled('div')`
  /* color: black !important; */
`;
const MemberPrice = styled('div')``;
const MemberPriceWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  .old-price {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    text-decoration: none;
    color: black !important;
    font-weight: bold !important;
    text-transform: uppercase;
    text-decoration: none !important;
  }
`;

const separatedPriceStyle = css`
  &.price-value-and-currency {
    display: flex;
    align-items: flex-end;
    gap: 0.3rem;
    color: inherit;

    .currency {
      margin-bottom: 4px;
      margin-left: 0px !important;
      color: inherit;
    }
    .price-value {
      color: inherit;
    }
  }
  &.reverse-order {
    flex-direction: row-reverse;
  }
`;

const SeparatedPrice = ({ price, selectedChannel }) => {
  //check if the channel is Norway
  const isNorway = selectedChannel?.id === 4;

  if (!price) return null;
  // Split the price into value and currency
  // This regex matches the currency part (kr, €, $, etc.)
  const valuePart = price
    ?.replace(/(\d+[\s\u00A0]*(?:[,.]\d+)?[\s\u00A0]*)([^\d\s,.]+)$/, '$1')
    .trim();

  const currencyPart =
    price?.match(/(\d+[\s\u00A0]*(?:[,.]\d+)?[\s\u00A0]*)([^\d\s,.]+)$/)?.[2] ||
    '';

  return (
    <div
      className={cx(
        'price-value-and-currency',
        separatedPriceStyle,
        isNorway && 'reverse-order'
      )}
    >
      <span className="price-value">{valuePart}</span>
      <span className="currency">{currencyPart}</span>
    </div>
  );
};

export const Price = ({
  className,
  style,
  negative,
  OnHidePriceComponent,
  fromPrice,
  hasMemberPrice,
  loggedIn,
  fixedPercentage,
  isColors,
  children,
  ...props
}) => {
  const { hasDiscount, formattedPricing, hidePrice } = usePrice(props);
  const { selectedChannel } = useContext(ChannelContext);
  // Remove decimals if === 00
  const cleanPrices = Object.entries(formattedPricing)?.reduce(
    (acc, [key, value]) => {
      const cleanedValue =
        value && value?.replace(/([,.]00)(?=\s*[^0-9])/g, '');
      acc[key] = cleanedValue;
      return acc;
    },
    {}
  );

  // Move currency to the start if Norway
  const adjustedPrices = cleanPrices; // adjustCurrencyForNorway(cleanPrices, isNorway);
  if (hidePrice) {
    if (OnHidePriceComponent) {
      return <OnHidePriceComponent {...props} />;
    } else {
      return null;
    }
  }

  if (isColors) {
    if (hasMemberPrice) {
      const memberPrice = props?.memberPrice?.incVat.toFixed(2);
      const currency =
        selectedChannel?.currency?.id === 'EUR'
          ? '€'
          : selectedChannel?.currency?.id === 'DKK'
          ? 'DKK'
          : 'kr';
      return (
        <MemberPrice className={cx('member-price', fromPrice && 'fr')}>
          {fromPrice && (
            <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
          )}
          <SeparatedPrice
            price={`${memberPrice} ${currency}`}
            selectedChannel={selectedChannel}
          />
        </MemberPrice>
      );
    } else {
      return (
        <NormalPrice className={cx('price normal-price', fromPrice && 'fr')}>
          {fromPrice && (
            <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
          )}
          <SeparatedPrice
            price={adjustedPrices?.price}
            selectedChannel={selectedChannel}
          />
        </NormalPrice>
      );
    }
  }

  return (
    <Wrapper className={className} style={style} {...props} data-flight-price>
      {hasDiscount ? (
        <>
          {hasMemberPrice ? (
            <MemberPriceWrapper>
              <MemberPrice className={cx('member-price', fromPrice && 'fr')}>
                {fromPrice && (
                  <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
                )}
                <SeparatedPrice
                  price={adjustedPrices?.price}
                  selectedChannel={selectedChannel}
                />
                {fixedPercentage > 0 && (
                  <div className="percentage">
                    -{fixedPercentage}
                    <span>%</span>
                  </div>
                )}
              </MemberPrice>
              <OldPrice className={cx('old-price', fromPrice && 'fr')}>
                {t('Not a member ')}
                {fromPrice && (
                  <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
                )}
                <SeparatedPrice
                  price={adjustedPrices?.previousPrice}
                  selectedChannel={selectedChannel}
                />
              </OldPrice>
            </MemberPriceWrapper>
          ) : (
            <>
              <NewPrice className={cx('new-price', fromPrice && 'fr')}>
                {fromPrice && (
                  <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
                )}
                <SeparatedPrice
                  price={adjustedPrices?.price}
                  selectedChannel={selectedChannel}
                />
                {fixedPercentage > 0 && (
                  <div className="percentage">
                    -{fixedPercentage}
                    <span>%</span>
                  </div>
                )}
              </NewPrice>
              <OldPrice className="old-price">
                <SeparatedPrice
                  price={adjustedPrices?.previousPrice}
                  selectedChannel={selectedChannel}
                />
              </OldPrice>
            </>
          )}
        </>
      ) : (
        <NormalPrice className={cx('price normal-price', fromPrice && 'fr')}>
          {fromPrice && (
            <span className={cx(fromPrice && 'fr')}>{t('Fr.')}</span>
          )}
          <SeparatedPrice
            price={adjustedPrices?.price}
            selectedChannel={selectedChannel}
          />
        </NormalPrice>
      )}
      {children}
    </Wrapper>
  );
};
Price.Wrapper = Wrapper;
Price.Normal = NormalPrice;
Price.Old = OldPrice;
Price.New = NewPrice;

//# sourceMappingURL=Price.js.map
